/**
 * Copy for the page a failed scan lands on.
 *
 * Kept apart from the record page's strings on purpose: these sentences make
 * claims about a licensee's certification, and each variant is tied to exactly
 * what the server was able to confirm. Only `invalid` — a certification the
 * server actually reported as not valid — may carry purchase advice.
 */
const translations = {
  hu: {
    langCurrent: "HU",
    langOther: "EN",

    // "checking": nothing has been established yet.
    checkingEyebrow: "ELLENŐRZÉS FOLYAMATBAN",
    checkingTitle: "Tanúsítvány ellenőrzése",
    checkingBody:
      "Egy pillanat, megnézzük ezt az azonosítót a tanúsítási nyilvántartásban.",

    // "invalid": the server reported certValid=false. The only variant that
    // may advise against a purchase.
    invalidEyebrow: "NINCS ÉRVÉNYES TANÚSÍTÁS",
    invalidTitle: "Ez a termék nem rendelkezik érvényes UltraGreen tanúsítással",
    invalidBody:
      "A beolvasott termék tanúsítása lejárt, vagy nem érvényes. Ne vásárolja meg ezt a terméket tanúsított termékként — a tanúsítás állapotát kérjük, ellenőrizze a gyártónál.",

    // "notFound": a 404. Says only what a 404 supports.
    notFoundEyebrow: "AZONOSÍTÓ NEM TALÁLHATÓ",
    notFoundTitle: "Ezt az azonosítót nem találjuk a nyilvántartásban",
    notFoundBody:
      "A beolvasott azonosítóhoz nem tartozik tanúsított termék a nyilvántartásunkban. Ez sérült kód, elgépelés vagy még nem közzétett bejegyzés esetén is előfordul — a tanúsítás állapotát kérjük, ellenőrizze a gyártónál.",

    // "unconfirmed": the check could not be made. Asserts nothing.
    unconfirmedEyebrow: "AZ ÁLLAPOT NEM ELLENŐRIZHETŐ",
    unconfirmedTitle: "Most nem tudjuk ellenőrizni ezt a tanúsítást",
    unconfirmedBody:
      "A tanúsítási nyilvántartás jelenleg nem érhető el, ezért nem tudjuk megmondani, hogy ez a termék tanúsított-e. Kérjük, próbálja meg kicsit később, vagy ellenőrizze a tanúsítás állapotát a gyártónál.",

    // No identifier at all — nothing is known about any product, so nothing
    // may be said about one.
    missingIdEyebrow: "NINCS AZONOSÍTÓ",
    missingIdTitle: "Nem érkezett termékazonosító",
    missingIdBody:
      "Ez az oldal egy beolvasott azonosítóhoz tartozó tanúsítást mutat, de most nem érkezett azonosító. Olvassa be újra a QR-kódot, vagy keressen rá a termékre a nyilvános listában.",

    labelProductName: "TERMÉK NEVE",
    labelScannedId: "BEOLVASOTT AZONOSÍTÓ",

    nextTitle: "Mit tehet most?",
    searchTitle: "Keresés a nyilvános listában",
    searchBody:
      "A tanúsított termékek és összetevők név szerint is kereshetők — ez sérült vagy rosszul beolvasott kódnál a leggyorsabb út.",
    searchAction: "Tanúsított termékek keresése",
    contactTitle: "Szóljon nekünk",
    contactBody:
      "Ha úgy látja, hogy ez tévedés, vagy egy termék jogosulatlanul használja a védjegyet, írjon a tanúsítónak.",
    contactEmail: "info@ultragreencert.com",

    footerCompany:
      "UltraGreen Kft. · 1039 Budapest, Batthyány utca 35/B. · Cg. 01-09-376313",
  },

  en: {
    langCurrent: "EN",
    langOther: "HU",

    checkingEyebrow: "CHECKING",
    checkingTitle: "Checking this certification",
    checkingBody:
      "One moment while we look this identifier up in the certification records.",

    invalidEyebrow: "NO VALID CERTIFICATION",
    invalidTitle: "This product does not hold a valid UltraGreen certification",
    invalidBody:
      "The scanned product's certification has expired or is not valid. Do not purchase this product as a certified product — please verify the certification status with the manufacturer.",

    notFoundEyebrow: "IDENTIFIER NOT FOUND",
    notFoundTitle: "We could not find this identifier in the records",
    notFoundBody:
      "The scanned identifier does not match any certified product in our records. This can happen with a damaged code, a typo, or a listing that is not yet published — please verify the certification status with the manufacturer.",

    unconfirmedEyebrow: "STATUS UNCONFIRMED",
    unconfirmedTitle: "We could not check this certification right now",
    unconfirmedBody:
      "The certification records could not be reached, so we cannot say whether this product is certified. Please try again shortly, or verify the certification status with the manufacturer.",

    missingIdEyebrow: "NO IDENTIFIER",
    missingIdTitle: "No product identifier was provided",
    missingIdBody:
      "This page shows the certification behind a scanned identifier, and none was provided. Please scan the QR code again, or look the product up in the public list.",

    labelProductName: "PRODUCT NAME",
    labelScannedId: "SCANNED IDENTIFIER",

    nextTitle: "What you can do",
    searchTitle: "Search the public list",
    searchBody:
      "Certified products and ingredients can be searched by name — the quickest route when a code is damaged or misread.",
    searchAction: "Search certified products",
    contactTitle: "Tell us",
    contactBody:
      "If you believe this is an error, or that a product is using the mark without being entitled to, write to the certifier.",
    contactEmail: "info@ultragreencert.com",

    footerCompany:
      "UltraGreen Kft. · 1039 Budapest, Batthyány utca 35/B. · Reg. 01-09-376313",
  },
};

export default translations;
